"use strict";
/**
 * https://www.figma.com/file/NDYFGMfDaxqqY41C55RDgl/%F0%9F%90%A5-NEW-DESIGN-SYSTEM?node-id=8500%3A33155&t=RlRyvbosnkJ5XVCD-1
 */
Object.defineProperty(exports, "__esModule", { value: true });
const baseStyle = {
    color: 'text-primary',
    fontFamily: 'rubik',
    fontWeight: 'weight-400',
    lineHeight: 'base',
    strong: { fontWeight: 'weight-500' },
    whiteSpace: 'pre-line',
};
const sizes = {
    lg: { fontSize: 'font-15', lineHeight: 'lh-22' },
    md: { fontSize: 'font-12', lineHeight: 'lh-16' },
    sm: { fontSize: 'font-10', lineHeight: 'lh-12' },
    xs: { fontSize: 'font-8', lineHeight: 'lh-10' },
};
const defaultProps = {
    size: 'md',
    variant: 'primary',
};
const TextTheme = {
    baseStyle,
    defaultProps,
    sizes,
};
exports.default = TextTheme;
